import {useCallback, useState} from "react";

/** Convenience hook returning a function that forces a re-render */
export function useForceRender(): () => void {
    const [, setAtom] = useState(Symbol());
    return useCallback(() => setAtom(Symbol()), [setAtom]);
}
